import React from 'react';
import { generateId } from '../../../shared/utils/generate-id';
import * as colors from '../../utils/colors';
import { useStrip } from '../hooks/useStrip';
import { GRID_MS, GRID_UNIT_SIZE, squareToPixel } from '../utils/graph.utils';

const MINIMUM_SPACING = squareToPixel(1 / 4);

export const Grid: React.FC = () => {
  const backgroundId = generateId('backgroundId');
  const { xScale, height } = useStrip();
  const size = xScale(GRID_MS);
  const points = makePoints(size);
  const showLine = size > MINIMUM_SPACING;

  return (
    <g className='grid'>
      <defs>
        <pattern
          id={backgroundId}
          width={size}
          height={size}
          patternUnits='userSpaceOnUse'
        >
          {showLine && (
            <line
              x1={0}
              y1={0}
              x2={size}
              y2={0}
              stroke={colors.gridLineColor}
              strokeWidth={GRID_UNIT_SIZE}
            />
          )}
          {showLine && (
            <line
              x1={0}
              y1={0}
              x2={0}
              y2={size}
              stroke={colors.gridLineColor}
              strokeWidth={GRID_UNIT_SIZE}
            />
          )}
          {points.map((i) => (
            <g key={i}>
              {points.map((j) => (
                <rect
                  key={j}
                  x={i}
                  y={j}
                  height={GRID_UNIT_SIZE}
                  width={GRID_UNIT_SIZE}
                  fill={colors.gridLineColor}
                />
              ))}
            </g>
          ))}
        </pattern>
      </defs>
      <rect
        className='grid'
        height={height}
        width='100%'
        fill={`url("#${backgroundId}")`}
      />
    </g>
  );
};
const makePoints = (size: number) =>
  size > MINIMUM_SPACING ? [1, 2, 3, 4].map((i) => (i * size) / 5) : [];
